import axios from 'axios';

export interface SharedPlayer {
    name: string;
    x: number;
    y: number;
    z: number;
}

export interface PlayerListSnapshot {
    active: boolean;
    online: boolean;
    expires_at: string | null;
    snapshot_updated_at: string | null;
    server_address: string | null;
    players: SharedPlayer[];
}

export interface CreatedPlayerListShare extends PlayerListSnapshot {
    token: string;
}

export const getStatus = () => axios.get<PlayerListSnapshot>('/player-list');
export const createShare = () => axios.post<CreatedPlayerListShare>('/player-list/share');
export const revokeShare = () => axios.delete<{ active: boolean }>('/player-list/share');
export const getPublicSnapshot = (token: string) =>
    axios.get<PlayerListSnapshot>(`/player-list/share/${encodeURIComponent(token)}`);
